import angular from 'angular';

// we do not have jQuery - maybe we will some day
if (!/^jQuery/i.test(angular.element.expando)) {
  angular.element.prototype.find = function findMonkeyPatch(selector) {
    return angular.element(this[0].querySelectorAll(selector));
  };
}
